export const BASE_SERVER_URL = "";

//export const BASE_SERVER_URL = "https://admin.byts.co.in";
// to use in prod
// uncomment the above line
// and romove the client proxy
